import {
    sla_code_coverage_key,
    sla_custom_feature_key,
    sla_default_feature_key,
    DC_FEATURE_KEY,
    APPROVALS_FEATURE_KEY,
    advance_automation_feature_key,
    assign_among_automation_feature_key,
    advance_automation_m4_feature_key,
    advance_automation_m3_feature_key,
    advance_automation_m5_feature_key,
    body_search_feature_key,
    CONVERSATION_ID_FEATURE_KEY,
    SM_CHAT_SUPPORT_FEATURE_KEY,
    LANDING_PAGE_REVAMP_FEATURE_KEY,
    PRICING_PAGE_REVAMP_2023_FEATURE_KEY,
    PRICING_PAGE_REVAMP_2024_FEATURE_KEY,
    POWERED_BY_HIVER_FOOTER_FEATURE_KEY,
    POWERED_FOOTER_BLACKLIST_FEATURE_KEY,
    LANDING_PAGE_REVAMP_M2_FEATURE_KEY,
    CHAT_BUSINESS_HOURS_RELEASE_KEY,
    LIVE_CHAT_CONFIGURATION,
    PREFILL_TEMPLATE_FEATURE_KEY,
    AI_SUMMARIZER_FEAT_KEY,
    AI_SUMMARIZER_UI_FEAT_KEY,
    EXPLORE_YOUR_PLAN_M2_FEATURE_KEY,
    EXPLORE_YOUR_PLAN_M3_FEATURE_KEY,
    EXPLORE_YOUR_PLAN_M4_FEATURE_KEY,
    SALESFORCE_FEATURE_KEY,
    INTEGRATION_NEWAUTH_FEAT_KEY,
    SLA_NEWAUTH_FEAT_KEY,
    CUSTOMER_PORTAL_DEV_FEAT_KEY,
    CUSTOMER_PORTAL_FEAT_KEY,
    ONBOARDING_CHECKLIST_KEY,
    csat_feature_key,
    AUTOMATIONS_NEWAUTH_FEATURE_KEY,
    CHAT_NEWAUTH_FEAT_KEY,
    HIVERAPI_DOMAIN_FEATURE_KEY,
    GROUP_TYPE_SM_SOURCE_USER_FIX_FEAT_KEY,
    PRICING_PAGE_REVAMP_2024_V2_FEATURE_KEY,
    SEAT_CONTRACTION_MODAL_RELEASE_KEY,
    ACCOUNT_DELETION_FORM_RELEASE_KEY,
    CUSTOM_FIELDS_DEV_FEAT_KEY,
    CSAT,
    CSAT_ENHANCEMENT,
    TIME_BASED_AUTOMATIONS,
    CUSTOM_FIELDS_FEAT_KEY,
    FEEDBACK_FORM_FEATURE_KEY,
    ADD_NEW_USER_FEAT_KEY,
    ACCOUNT_DELETION_DESCRIPTION,
    PRECHAT_FORM_COUNTRY_CODE_FEATURE_KEY,
    SM_TYPE_SIGNUP_FLOW_KEY,
    OUT_OF_OFFICE_SETTINGS_FK,
    AUTOMATION_NEW_UI_FK,
    FREEMIUM_PLAN_FK,
    CUSTOM_DOMAIN_FEATURE_KEY,
    CUSTOM_DOMAIN_RELEASE_KEY,
    CSAT_MIGRATION,
    CUSTOM_FIELDS_AUTOMATION_FEAT_KEY,
    ADD_FOLLOWERS_THROUGH_AUTOMATIONS,
    CONVERSATION_FOLLOWERS_FK,
    PLG_OUT_OF_OFFICE_NUDGE,
    OUT_OF_OFFICE,
    JOIN_HIVER_COMMUNITY_FK,
    PROMOTIONAL_BANNER_FK,
    ONBOARDING_JOURNEY_30DAYS,
    CHAT_TRANSCRIPTS,
    KNOWLEDGE_BASE_UPGRADED_TAG_FEAT_KEY,
    CUSTOM_CONNECTORS_FEATURE_KEY,
    LAST_100_MAIL_SYNC,
    GROWTH_24_PLAN_FK,
    APPROVALS_IN_AUTOMATION,
    AI_REPHRASE_FEATURE_KEY,
    AI_REPHRASE_RELEASE_KEY,
    MANDATORY_CUSTOM_FIELD_FEATURE_KEY,
    CUSTOM_FIELD_TIMEZONE_INSENSITIVE,
    SCHEDULED_AUTOMATIONS,
    PRICING_PAGE_REVAMP_2025,
    SLA_PLG_NUDGE2_PART1_FK,
    SLA_PLG_NUDGE2_PART2_FK,
    AI_BLACKLIST,
    AI_COPILOT,
    AI_SETTINGS,
    AI_COPILOT_V2,
    AI_COPILOT_UPLOAD_SOURCE,
    AI_COPILOT_PAST_CONV,
    AI_COPILOT_UPLOAD_LIMIT_INC,
    CONNECTORS_IN_AUTOMATION,
    MICROSOFT_CLARITY_INTEGRATION,
    STRIPE_SCA_ENABLED_FK,
    TRIAL_MAIL_SYNC_FIX,
    AI_TAGS_DESCRIPTION,
    AI_ADOPTION_GUIDERS_FK,
    AI_COPILOT_DOWNLOAD_LINKS_FK,
    CHATBOTS_AUTO_SAVE,
    AI_COPILOT_LIBRARY,
    DAY_TIMEZONE_SELECT,
    CUSTOMER_PORTAL_STATIC_FIELDS,
    AI_COPILOT_ADOPTION_BANNER,
    AUTORESPONDER_EXCLUDE_DOMAIN,
    CONNECTORS_UNIFIED_VIEW_FEAT_KEY,
    DEVELOPER_FEATURE_API_KEY,
    DEVELOPER_RELEASE_API_KEY,
    CUSTOM_OBJECTS_RELEASE_KEY,
    CUSTOM_OBJECTS_FEATURE_KEY,
    CSAT_ADVANCED_SETTINGS,
    TIERED_PRICING_REVAMP_FEATURE_KEY,
    REPLY_TO_EMAIL_ACTION,
    AI_CUSTOM_FIELDS_FEATURE_KEY,
    PI_AUTOMATIONS_FEATURE_KEY,
    AI_AUTO_TAGGING_FEATURE_KEY,
    AI_AUTO_TAGGING_V2_FEATURE_KEY,
    AI_AUTO_TAGGING_DISCOVERABILITY_GUIDERS,
    AI_CUSTOM_FIELD_GUIDER_FEATURE_KEY
} from "../constants";
import { isFeatureEnabled } from "./utility"

export const isAddNewUserEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, ADD_NEW_USER_FEAT_KEY);
}

//  mainly SLA lite
export const hasAccessDefaultSla = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, sla_default_feature_key);
}

//  mainly Complete SLA
export const hasAccessCustomSla = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, sla_custom_feature_key);
}

export const hasAccessToSla = (availableFeatures) => {
    return hasAccessDefaultSla(availableFeatures) ||  hasAccessCustomSla(availableFeatures)
}

export const hasBHReleaseAccess = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CHAT_BUSINESS_HOURS_RELEASE_KEY);
}

export const hasAccessToBHFtr = (availableFeatures) => {
    return hasAccessToSla(availableFeatures);
}

export const isBHCrown = (availableFeatures) => {
    return hasBHReleaseAccess(availableFeatures) && !hasAccessToBHFtr(availableFeatures);
}

export const isSlaV2CodeEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, sla_code_coverage_key);
}

export const isDCEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, DC_FEATURE_KEY);
}

export const isApprovalsEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, APPROVALS_FEATURE_KEY);
}

export const isAdvanceAutomationEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, advance_automation_feature_key);
}

export const isAdvanceAutomationM4Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, advance_automation_m4_feature_key);
}

export const isAdvanceAutomationM3Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, advance_automation_m3_feature_key);
}

export const isAdvanceAutomationM5Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, advance_automation_m5_feature_key);
}

export const isBodySearchFeatureKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, body_search_feature_key);
}

export const isAssignAmongAutomationEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, assign_among_automation_feature_key);
}

export const isConversationIdFeatureKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CONVERSATION_ID_FEATURE_KEY);
}

export const isSmChatSupportFeatureKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, SM_CHAT_SUPPORT_FEATURE_KEY);
}

export const isLandingPageRevampEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, LANDING_PAGE_REVAMP_FEATURE_KEY);
}

export const isPricingPlan23Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, PRICING_PAGE_REVAMP_2023_FEATURE_KEY)
}

export const isPricingPlan24Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, PRICING_PAGE_REVAMP_2024_FEATURE_KEY)
}

export const isPricingPlan24V2Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, PRICING_PAGE_REVAMP_2024_V2_FEATURE_KEY)
}

export const isPoweredByHiverEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, POWERED_BY_HIVER_FOOTER_FEATURE_KEY)
}

export const isPoweredFooterBlacklistEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, POWERED_FOOTER_BLACKLIST_FEATURE_KEY)
}

export const isLandingPageRevampM2Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, LANDING_PAGE_REVAMP_M2_FEATURE_KEY);
}

export const isPreFillTemplateEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, PREFILL_TEMPLATE_FEATURE_KEY);
}

export const isAISummarizerEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures,AI_SUMMARIZER_FEAT_KEY);
}

export const isAISummarizerUIEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures,AI_SUMMARIZER_UI_FEAT_KEY);
}

export const isExploreYourPlanM2Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, EXPLORE_YOUR_PLAN_M2_FEATURE_KEY);
}

export const isExploreYourPlanM3Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, EXPLORE_YOUR_PLAN_M3_FEATURE_KEY);
}

export const isExploreYourPlanM4Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, EXPLORE_YOUR_PLAN_M4_FEATURE_KEY);
}

export const isSalesforceIntegrationEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, SALESFORCE_FEATURE_KEY);
}

export const isIntegrationNewAuthEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, INTEGRATION_NEWAUTH_FEAT_KEY );
}

export const isNewChatAuthEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CHAT_NEWAUTH_FEAT_KEY);
}

export const isLiveChatConfigurationEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, LIVE_CHAT_CONFIGURATION);
}

export const isSLANewAuthEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, SLA_NEWAUTH_FEAT_KEY );
}

export const isCustomerPortalDevKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOMER_PORTAL_DEV_FEAT_KEY );
}

export const isCustomerPortalEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOMER_PORTAL_FEAT_KEY );
}

export const isOnboardingChecklistEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures,ONBOARDING_CHECKLIST_KEY)
}

export const isCsatFeatureEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, csat_feature_key);
}

export const isAutomationsNewAuthEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AUTOMATIONS_NEWAUTH_FEATURE_KEY);
}

export const isHiverApiDomainEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, HIVERAPI_DOMAIN_FEATURE_KEY);
}

export const isGroupTypeSmSourceUserFixEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, GROUP_TYPE_SM_SOURCE_USER_FIX_FEAT_KEY);
}

export const isSeatContractionModalReleaseKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, SEAT_CONTRACTION_MODAL_RELEASE_KEY);
}

export const isAccountDeletionFormReleaseKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, ACCOUNT_DELETION_FORM_RELEASE_KEY);
}

export const isCustomFieldsDevKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOM_FIELDS_DEV_FEAT_KEY);
}

export const isTimeBasedAutomationEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, TIME_BASED_AUTOMATIONS);
}

export const isCustomerFieldsEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOM_FIELDS_FEAT_KEY)
}

export const isFeedbackFormEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, FEEDBACK_FORM_FEATURE_KEY);
}

export const isCsatAvailable = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CSAT);
}

export const isCsatEnhancementAvailable = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CSAT_ENHANCEMENT);
}

export const isAccountDeletionDescriptionKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, ACCOUNT_DELETION_DESCRIPTION);
}

export const isPreChatCountryCodeEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, PRECHAT_FORM_COUNTRY_CODE_FEATURE_KEY);
}

export const isSmTypeSignupFlowKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, SM_TYPE_SIGNUP_FLOW_KEY);
}

export const isOutOfOfficeSettingsEnabled = (availableFeatures)=>{
    return isFeatureEnabled(availableFeatures, OUT_OF_OFFICE_SETTINGS_FK);
}

export const isAutomationNewUIEnabled = (availableFeatures)=>{
    return isFeatureEnabled(availableFeatures,AUTOMATION_NEW_UI_FK)
}

export const isFreemiumPlanEnabled = (availableFeatures)=>{
    return isFeatureEnabled(availableFeatures,FREEMIUM_PLAN_FK)
}

export const isCustomDomainEnabledForCurrentPlan = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOM_DOMAIN_FEATURE_KEY)
}

export const isCustomDomainAvailable = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOM_DOMAIN_RELEASE_KEY)
}


export const isAddFollowersThroughAutomationsAvailable = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, ADD_FOLLOWERS_THROUGH_AUTOMATIONS);
}

export const isConversationFollowersAvailable = (availableFeatures)=>{
    return isFeatureEnabled(availableFeatures, CONVERSATION_FOLLOWERS_FK);
}

export const isCsatMigrationEnabled = (availableFeatures)=>{
    return isFeatureEnabled(availableFeatures, CSAT_MIGRATION)
}

export const isCustomConnectorsEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOM_CONNECTORS_FEATURE_KEY);
}

export const isCustomfieldsAutomationEnabled = (availableFeatures)=>{
    return isFeatureEnabled(availableFeatures,CUSTOM_FIELDS_AUTOMATION_FEAT_KEY)
}

export const isPlgOutOfOfficeNudgeAvailable = (availableFeatures)=>{
    return isFeatureEnabled(availableFeatures,PLG_OUT_OF_OFFICE_NUDGE)
}

export const isOutOfOfficeAvailable = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures,OUT_OF_OFFICE)
}

export const isJoinHiverCommunityEnabled = (availableFeatures)=>{
    return isFeatureEnabled(availableFeatures,JOIN_HIVER_COMMUNITY_FK)
}

export const isPromotionalBannerEnabled = (availableFeatures) => {
  return isFeatureEnabled(availableFeatures, PROMOTIONAL_BANNER_FK);
}

export const isOnboardingJourney30DaysAvailable = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, ONBOARDING_JOURNEY_30DAYS);
}

export const isChatTransciptsEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CHAT_TRANSCRIPTS);
}

export const isKnowledgeBaseUpgradedTagEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, KNOWLEDGE_BASE_UPGRADED_TAG_FEAT_KEY);
}

export const is100MailSyncEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, LAST_100_MAIL_SYNC);
}

export const isGrowth24PlanEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, GROWTH_24_PLAN_FK);
}

export const isApprovalsInAutomationEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, APPROVALS_IN_AUTOMATION);
}

export const isAIRephraseFeatureEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_REPHRASE_FEATURE_KEY);
}

export const isAIRephraseReleaseKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_REPHRASE_RELEASE_KEY);
}

export const isMandatoryCustomFieldFeatureKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, MANDATORY_CUSTOM_FIELD_FEATURE_KEY);
}

export const isCustomFieldsTimezoneInsensitive = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOM_FIELD_TIMEZONE_INSENSITIVE);
}

export const isScheduledAutomationsEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, SCHEDULED_AUTOMATIONS);
}

export const isPricingPageRevamp2025Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, PRICING_PAGE_REVAMP_2025);
}

export const isPlgSlaNudge2Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, SLA_PLG_NUDGE2_PART1_FK) ||
        isFeatureEnabled(availableFeatures, SLA_PLG_NUDGE2_PART2_FK);
}

export const isAIBlacklistFeatureEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_BLACKLIST);
}


export const isAiCoPilotEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_COPILOT);
}


export const isAiSettingsEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_SETTINGS);
}

export const isAiCopilotV2Enabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_COPILOT_V2);
}

export const isAiCopilotLibraryEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_COPILOT_LIBRARY);
}

export const isAiCopilotUploadSourceEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_COPILOT_UPLOAD_SOURCE);
}

export const isAiCopilotPastConversationEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_COPILOT_PAST_CONV);
}

export const isAiCopilotUploadLimitIncreased = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_COPILOT_UPLOAD_LIMIT_INC);
}

export const isConnectorsInAutomationEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CONNECTORS_IN_AUTOMATION);
}

export const isMicrosoftClarityIntegrationEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, MICROSOFT_CLARITY_INTEGRATION);
}

export const isCustomerPortalAddFields = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOMER_PORTAL_STATIC_FIELDS);
}

export const isStripeScaEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, STRIPE_SCA_ENABLED_FK);
}

export const is10MailSyncForTrialEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, TRIAL_MAIL_SYNC_FIX);
}

export const isAiAdoptionGuidersEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_ADOPTION_GUIDERS_FK);
}

export const isAiCopilotDownloadLinksEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_COPILOT_DOWNLOAD_LINKS_FK);
}

export const isAiTagsDescriptionEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_TAGS_DESCRIPTION);
}

export const isChatbotsAutoSaveEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CHATBOTS_AUTO_SAVE);
}
export const  isDayTimeZoneSelectEnabled = (availableFeatures)   => {
    return isFeatureEnabled(availableFeatures,DAY_TIMEZONE_SELECT)
} 

export const isAiCopilotAdoptionBannerEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_COPILOT_ADOPTION_BANNER);
}

export const isAutoresponderExcludeDomainEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AUTORESPONDER_EXCLUDE_DOMAIN);
}

export const isConnectorsUnifiedViewEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CONNECTORS_UNIFIED_VIEW_FEAT_KEY );
}

export const isDeveloperApiEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, DEVELOPER_FEATURE_API_KEY) && isFeatureEnabled(availableFeatures, DEVELOPER_RELEASE_API_KEY);
}

export const isCustomObjectsReleaseKeyEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOM_OBJECTS_RELEASE_KEY);
}

export const isCustomObjectsFeatureEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CUSTOM_OBJECTS_FEATURE_KEY);
}
export const isCsatAdvancedSettingsEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, CSAT_ADVANCED_SETTINGS);
}

export const isTieredPricingFeatureEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures,TIERED_PRICING_REVAMP_FEATURE_KEY);
}

export const isReplyToEmailActionEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, REPLY_TO_EMAIL_ACTION);
}

export const isAiCustomFieldsFeatureEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_CUSTOM_FIELDS_FEATURE_KEY);
}

export const isPersonalInboxAutomationsEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, PI_AUTOMATIONS_FEATURE_KEY);
}

export const isAiAutoTaggingFeatureEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_AUTO_TAGGING_FEATURE_KEY);
}

export const isAiAutoTaggingV2FeatureEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_AUTO_TAGGING_V2_FEATURE_KEY);
}

export const isAiAutoTaggingDiscoverabilityGuidersEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_AUTO_TAGGING_DISCOVERABILITY_GUIDERS);
}

export const isAiCustomFieldGuiderEnabled = (availableFeatures) => {
    return isFeatureEnabled(availableFeatures, AI_CUSTOM_FIELD_GUIDER_FEATURE_KEY);
}

